import { render, staticRenderFns } from "./sort.component.vue?vue&type=template&id=06cdf508&scoped=true&"
import script from "./sort.component.vue?vue&type=script&lang=js&"
export * from "./sort.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdf508",
  null
  
)

export default component.exports